var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#173593"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.7258C7.5 10.058 8.04183 9.51614 8.70968 9.51614H11.129C11.7994 9.51614 12.3387 10.058 12.3387 10.7258V13.1452C12.3387 13.8155 11.7994 14.3549 11.129 14.3549H8.70968C8.04183 14.3549 7.5 13.8155 7.5 13.1452V10.7258ZM10.7258 12.742V11.129H9.1129V12.742H10.7258ZM31.6935 11.129C32.1371 11.129 32.5 11.4899 32.5 11.9355C32.5 12.379 32.1371 12.742 31.6935 12.742H15.5645C15.121 12.742 14.7581 12.379 14.7581 11.9355C14.7581 11.4899 15.121 11.129 15.5645 11.129H31.6935ZM31.6935 19.1936C32.1371 19.1936 32.5 19.5565 32.5 20C32.5 20.4436 32.1371 20.8065 31.6935 20.8065H15.5645C15.121 20.8065 14.7581 20.4436 14.7581 20C14.7581 19.5565 15.121 19.1936 15.5645 19.1936H31.6935ZM31.6935 27.2581C32.1371 27.2581 32.5 27.621 32.5 28.0645C32.5 28.5081 32.1371 28.871 31.6935 28.871H15.5645C15.121 28.871 14.7581 28.5081 14.7581 28.0645C14.7581 27.621 15.121 27.2581 15.5645 27.2581H31.6935ZM11.129 17.5807C11.7994 17.5807 12.3387 18.12 12.3387 18.7903V21.2097C12.3387 21.8801 11.7994 22.4194 11.129 22.4194H8.70968C8.04183 22.4194 7.5 21.8801 7.5 21.2097V18.7903C7.5 18.12 8.04183 17.5807 8.70968 17.5807H11.129ZM9.1129 19.1936V20.8065H10.7258V19.1936H9.1129ZM7.5 26.8549C7.5 26.1845 8.04183 25.6452 8.70968 25.6452H11.129C11.7994 25.6452 12.3387 26.1845 12.3387 26.8549V29.2742C12.3387 29.9446 11.7994 30.4839 11.129 30.4839H8.70968C8.04183 30.4839 7.5 29.9446 7.5 29.2742V26.8549ZM10.7258 28.871V27.2581H9.1129V28.871H10.7258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEvents);
export default __webpack_public_path__ + "static/media/activeEvents.e79a0b2dbbf7126c2d12935653b16452.svg";
export { ForwardRef as ReactComponent };